module.exports = __webpack_public_path__ + "img/car.3eef7f35.svg";